import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-poh-top',
  templateUrl: './poh-top.component.html',
  styleUrls: ['./poh-top.component.css']
})
export class PohTopComponent implements OnInit {
    pohKeynoTop;

    public edit?: Edit;

    public selectListPoStatuses: PoStatusItem[] = [];

    public itemsListSubPos: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.pohKeynoTop = this.stateService.getStateParams()['poh_keyno_top'];
    }

    private async loadEdit() {
        if (!!this.pohKeynoTop) {
            this.edit = (await this.datatask.Post(1350, { poh_keyno_top: this.pohKeynoTop }))[0];
        }
    }

    private async loadPoStatuses() {
        this.selectListPoStatuses = await this.datatask.Post(1348, { add_all: '0' });
    }

    private async loadSubPos() {
        if (this.edit) {
            this.itemsListSubPos = await this.datatask.Post(1351, { poh_keyno_top: this.edit.poh_keyno_top });
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'selectreport':
                this.stateService?.go('selectreport', {
                    webpage_name: this.stateService.getCurrentName(),
                    argtype: 'poh_keyno_top',
                    argvalue: this.edit?.poh_keyno_top
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadPoStatuses();
        this.loadSubPos();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    poh_keyno_top: string;
    po_keyno: string;
    prod_id: string;
    prod_name_long: string;
    quantity: string;
    postatus_no: string;
    lastdt_finish: string;
    stock_keyno: string;
}

interface PoStatusItem {
    postatus_no: number;
    postatus_name: string;
    orderby: number;
}
